"use client";

// import { SessionProvider } from "next-auth/react";
import { FC, ReactNode, createContext, useEffect, useState } from "react";

import NavigationProvider from "@/context/NavigationContext";
import useMediaQuery from "@/hooks/useMediaQuery";

import BannerContextProvider from "./BannerContext";

interface TemplateProps {
  fixedHeader: boolean;
  visibleHeader: boolean;
  setVisibleHeader: (visible: boolean) => void;
}

export const TemplateContext = createContext<TemplateProps>({
  fixedHeader: false,
  visibleHeader: true,
  setVisibleHeader: () => {},
});
interface Props {
  children: ReactNode;
  /**
   * true will handle it as fixed - no hide on scroll
   * false will handle it as sticky - hide on scroll (default)
   */
  fixedHeader?: boolean;
  fixedMobileOnly?: boolean;
}
const TemplateProvider: FC<Props> = ({ children, fixedHeader = false, fixedMobileOnly }) => {
  const [visibleHeader, setVisibleHeader] = useState(true);
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
  }, []);
  return (
    <TemplateContext.Provider value={{ fixedHeader: fixedMobileOnly ? !isDesktop : fixedHeader, visibleHeader, setVisibleHeader }}>
      {/* <SessionProvider> */}
      <BannerContextProvider>
        <NavigationProvider>{children}</NavigationProvider>
      </BannerContextProvider>
      {/* </SessionProvider> */}
    </TemplateContext.Provider>
  );
};
export default TemplateProvider;
